import React from 'react';
import { FiCheckCircle, FiCircle, FiXCircle, FiClock } from 'react-icons/fi';
import StatusPill from './StatusPill';

const STEP_ICON = {
  APPROVED: { icon: FiCheckCircle, color: 'text-success' },
  REJECTED: { icon: FiXCircle, color: 'text-danger' },
  PENDING: { icon: FiClock, color: 'text-warning' },
  CURRENT: { icon: FiClock, color: 'text-info' },
};

export default function WorkflowTimeline({ workflow }) {
  if (!workflow) return null;
  const flow = workflow.approverFlow || [];
  if (flow.length === 0) {
    return (
      <div className="rounded-md bg-slate-50 px-4 py-3 text-xs text-ink-muted">
        No approver steps recorded.
      </div>
    );
  }
  const currentStep = workflow.currentStep;

  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between border-b border-slate-100 pb-2">
        <h4 className="text-xs font-semibold uppercase tracking-wider text-ink-muted">
          Approval Flow
        </h4>
        <StatusPill value={workflow.workflowStatus} />
      </div>
      <ol className="space-y-2 pt-3">
        {flow.map((step, idx) => {
          const status = step.status || (step.step === currentStep ? 'CURRENT' : 'PENDING');
          const cfg = STEP_ICON[status] || STEP_ICON.PENDING;
          const Icon = cfg.icon || FiCircle;
          return (
            <li key={idx} className="flex items-start gap-3 text-sm">
              <Icon className={`mt-0.5 ${cfg.color}`} />
              <div className="flex-1">
                <div className="font-medium text-ink">
                  Step {step.step ?? idx + 1}: {step.role || 'Approver'}
                </div>
                {(step.username || step.userId) && (
                  <div className="text-xs text-ink-muted">Approver: {step.username || `User #${step.userId}`}</div>
                )}
                {step.comment && (
                  <div className="mt-0.5 text-xs italic text-ink-muted">“{step.comment}”</div>
                )}
              </div>
              <StatusPill value={status} />
            </li>
          );
        })}
      </ol>
    </div>
  );
}
